import { isNullish } from '@epicuro-next/utilities';

export function formatDateRangeSeparator(date: string | null) {
  if (isNullish(date)) return '';

  const formattedDate = date.split(/[-/]|\s\b/g);

  return formattedDate
    .map((item) => (item.length === 1 ? `0${item}` : item))
    .join('.');
}
